import { useEffect } from "react";

/**
 * /$locale/login is a logical entry point — it hands the browser off
 * to the BFF's /auth/login which in turn drives the OIDC flow on
 * Keycloak. Keeping the route here means existing deep-links and
 * marketing CTAs (`/de/login`) keep working unchanged.
 *
 * The navigation is deferred to the next tick so React finishes the
 * mount before the browser tears the page down. Without that, in
 * StrictMode the effect fires twice (mount + cleanup + remount) and
 * the second window.location call can race with TanStack-Router's
 * own navigation, which we observed as a flicker loop.
 */
export function LoginRedirect() {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      window.location.assign("/auth/login");
    }, 0);
    return () => window.clearTimeout(timer);
  }, []);
  return (
    <main className="grid min-h-dvh place-items-center text-sm text-muted-foreground">
      Weiterleitung zu Keycloak…
    </main>
  );
}
